"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditBankProgram = void 0;
var react_1 = __importDefault(require("react"));
var CreditBankProgram_module_scss_1 = __importDefault(require("./CreditBankProgram.module.scss"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var selectors_2 = require("../../redux/selectors");
var getPayment_1 = require("../../helpers/car/getPayment");
var formatPrice_1 = require("../../helpers/formatPrice");
var banksListSlice_1 = require("../../redux/slice/banksListSlice");
var CreditBankProgram = function (_a) {
    var program = _a.program;
    var dispatch = (0, react_redux_1.useDispatch)();
    var targetProgram = (0, react_redux_1.useSelector)(selectors_1.banksListSelector).targetProgramId;
    var creditTerm = (0, react_redux_1.useSelector)(selectors_2.paymentSelector).creditTerm;
    var initialContribution = (0, react_redux_1.useSelector)(selectors_2.paymentSelector).initialContribution;
    var carPrice = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.car.carSelect.price;
    var setBankTarget = function () {
        dispatch((0, banksListSlice_1.setTargetBankId)(program.bank_id));
        dispatch((0, banksListSlice_1.setTaretProgramId)(targetProgram === program.id ? null : program.id));
    };
    return (react_1.default.createElement("section", { className: CreditBankProgram_module_scss_1.default.bank_program },
        react_1.default.createElement("h5", { className: CreditBankProgram_module_scss_1.default.bank_program__name }, program.program_name),
        react_1.default.createElement("span", { className: CreditBankProgram_module_scss_1.default.bank_program__rate },
            program.interest_rate,
            "%"),
        react_1.default.createElement("span", { className: CreditBankProgram_module_scss_1.default.bank_program__payment },
            (0, formatPrice_1.formatPrice)((0, getPayment_1.getPayment)(carPrice, initialContribution, creditTerm, program.interest_rate)),
            " \u20BD"),
        react_1.default.createElement("button", { className: CreditBankProgram_module_scss_1.default.bank_program__btn, onClick: setBankTarget }, targetProgram === program.id ? 'Выбрано' : 'Выбрать')));
};
exports.CreditBankProgram = CreditBankProgram;
